export const ALL_REDIRECT_REPORT_REQUEST = "ALL_REDIRECT_REPORT_REQUEST";
export const ALL_REDIRECT_REPORT_SUCCESS = "ALL_REDIRECT_REPORT_SUCCESS";
export const ALL_REDIRECT_REPORT_FAIL = "ALL_REDIRECT_REPORT_FAIL";

export const GET_REDIRECT_BUYER_DIALOG_REQUEST = "GET_REDIRECT_BUYER_DIALOG_REQUEST";
export const GET_REDIRECT_BUYER_DIALOG_SUCCESS = "GET_REDIRECT_BUYER_DIALOG_SUCCESS";
export const GET_REDIRECT_BUYER_DIALOG_FAIL = "GET_REDIRECT_BUYER_DIALOG_FAIL";

export const CREATE_USER_BLOCK_REPORT_REQUEST = "CREATE_USER_BLOCK_REPORT_REQUEST";
export const CREATE_USER_BLOCK_REPORT_SUCCESS = "CREATE_USER_BLOCK_REPORT_SUCCESS";
export const CREATE_USER_BLOCK_REPORT_FAIL = "CREATE_USER_BLOCK_REPORT_FAIL";